var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Volume",
    clipPath: "url(#clip0_146_990)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.6241 10.948C21.2581 11.314 21.2581 11.9077 21.6241 12.2737C21.8736 12.5232 22.095 12.793 22.2872 13.0796C22.8677 13.9453 23.1797 14.9634 23.1797 16.0293C23.1797 17.0952 22.8677 18.1133 22.2872 18.9793C22.095 19.2657 21.8736 19.5354 21.6241 19.7849C21.2581 20.1512 21.2581 20.7447 21.6241 21.1106C21.8072 21.2937 22.0472 21.3853 22.2872 21.3853C22.5269 21.3853 22.7669 21.2937 22.95 21.1106C24.3072 19.7534 25.0547 17.9488 25.0547 16.0293C25.0547 14.1099 24.3072 12.3052 22.95 10.9478C22.584 10.5818 21.9903 10.5818 21.6241 10.948Z",
    fill: "#650675"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.8611 6.03687C27.4951 5.67065 26.9014 5.67065 26.5354 6.03687C26.1692 6.40283 26.1692 6.99634 26.5354 7.36255C26.7676 7.59497 26.9885 7.83472 27.1982 8.08057C31.0928 12.645 31.0928 19.4138 27.1982 23.9783C26.9885 24.2241 26.7676 24.4639 26.5354 24.696C26.1692 25.0623 26.1692 25.6558 26.5354 26.022C26.7183 26.2051 26.9583 26.2964 27.1982 26.2964C27.438 26.2964 27.678 26.2051 27.8611 26.022C30.5303 23.3528 32.0002 19.804 32.0002 16.0293C32.0002 12.2546 30.5303 8.70581 27.8611 6.03687Z",
    fill: "#650675"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.592 2.61383C15.4265 2.07867 14.0979 2.26544 13.125 3.10162L6.07861 9.1568H0.9375C0.419678 9.1568 0 9.57648 0 10.0943V21.9651C0 22.4827 0.419678 22.9026 0.9375 22.9026H6.07861L13.125 28.9578C13.7302 29.4781 14.4731 29.7469 15.229 29.7469C15.688 29.7469 16.1516 29.6478 16.592 29.4456C17.7578 28.9102 18.4819 27.7808 18.4819 26.4981V5.56134C18.4819 4.27838 17.7578 3.14923 16.592 2.61383ZM16.6069 26.4981C16.6069 27.0474 16.3088 27.5123 15.8096 27.7415C15.3103 27.9708 14.7637 27.8939 14.3472 27.5357L7.36353 21.5347V10.5247L14.3472 4.5235C14.7637 4.16559 15.3105 4.08868 15.8096 4.31793C16.3088 4.54718 16.6069 5.01202 16.6069 5.56134V26.4981ZM1.875 11.0318H5.48853V21.0276H1.875V11.0318Z",
    fill: "#650675"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_146_990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/volume.ecea76d02981cca6f176635a889bcd74.svg";
export { ForwardRef as ReactComponent };